import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.pure = bracketIndenting()
